<template>
  <path
    d="M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM12 13.0002C11.45 13.0002 11 12.5502 11 12.0002V8.00024C11 7.45024 11.45 7.00024 12 7.00024C12.55 7.00024 13 7.45024 13 8.00024V12.0002C13 12.5502 12.55 13.0002 12 13.0002ZM13 17.0002H11V15.0002H13V17.0002Z"
  />
</template>
